<template>
    <v-expansion-panels
        v-model="selectedPanel"
        accordion
        class="panels-wrapper elevation-0"
    >
        <v-expansion-panel
            v-for="(item, i) in items"
            :key="i"
            @change="sendAnalyticsEvent(item.question)"
        >
            <v-expansion-panel-header>
                <v-icon class="action-icon" slot="actions">{{
                    panelIconList[i]
                }}</v-icon
                ><span class="action-text">{{ item.question }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div class="answer-text" v-html="item.answer"></div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
export default {
    name: 'accordion',
    props: {
        items: {
            type: Array,
            required: true,
        },
        analyticsPrefix: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedPanel: undefined,
        };
    },
    computed: {
        panelIconList() {
            return this.items.map((val, index) =>
                index === this.selectedPanel ? 'mdi-minus' : 'mdi-plus'
            );
        },
    },
    methods: {
        sendAnalyticsEvent(value) {
            window.dataLayer.push({
                event: 'FAQ Expand',
                'FAQ Title': `${this.analyticsPrefix}${value}`,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.v-expansion-panels.elevation-0 {
    z-index: auto;
}
.v-expansion-panel-header {
    font-size: 18px !important;
    font-weight: bold;
    min-height: 52px;
}
.action-text {
    padding-left: 44px;
    line-height: 21px;
}
.answer-text {
    padding-left: 44px;
    padding-bottom: 16px;
}

@include break('sm') {
    .v-expansion-panel-header {
        min-height: 70px;
    }
}
</style>

<style lang="scss">
.panels-wrapper {
    .v-expansion-panel-header__icon {
        position: absolute;
        top: 1em;
    }
    .v-expansion-panel-content__wrap {
        padding: 0;
    }
    .v-expansion-panel-header {
        padding: 20px;
    }
    .v-expansion-panel {
        background-color: transparent !important;
        color: rgba(0, 0, 0, 1) !important;
    }

    .answer-text p:last-child {
        margin-bottom: 0 !important;
    }
}

@include break('sm') {
    .panels-wrapper {
        .v-expansion-panel-header__icon {
            top: 1.5em;
        }
    }
}
</style>
